module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Seelisberg_UR-87dcf2d8a4ff319984f2f91142223b4b.svg";